export const GameplayActionEvent = 'gameplayaction';

export const GameplayActionType = {
    PAUSE: 'pause-resume',
    RESET: 'reset',
    DIRECTION: 'direction'
};
